module.exports = __webpack_public_path__ + "img/1F1F3-1F1EA.838b9985.svg";